import React from "react";
import { Outlet } from "react-router-dom";

const ProfileComponent = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default ProfileComponent;
